import React from 'react';
import { AlertDismissable } from './AlertDismissable';
import { observer } from 'mobx-react';

type AlertGeneratorProps = {
    alertMessage: {
        message: string,
        style: string,
        show: boolean,
    },
    hideAlert: () => void
};

@observer
class AlertGenerator extends React.Component<AlertGeneratorProps> {
    render() {
        const { show, style, message } = this.props.alertMessage;
        const { hideAlert } = this.props;
        return (
            <AlertDismissable show={show} style={style} hideAlert={hideAlert}>
                {message}
            </AlertDismissable>
        );
    }
}



export { AlertGenerator };
